import React from 'react'

const ChatBotIcon = props => {
  return (
    <svg
      id='chatBotIcon'
      className={props.classProp}
      style={{ position: 'absolute', bottom: '40px', right: '40px' }}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="226"
      height="200"
      viewBox="0 0 226 200"
    >
      <defs>
        <path id="4tw4fwloka" d="M0 0h111.842v104.016H0z" />
        <path id="aibu7efh9c" d="M0 0h225.139v194.064H0z" />
      </defs>
      <g fill="none" fill-rule="evenodd">
        <g transform="translate(92.608)">
          <mask id="m6sm88bjdb" fill="#fff">
            <use xlinkHref="#4tw4fwloka" />
          </mask>
          <path
            d="M10.395 79.623h11.292c.188 11.043-2.08 15.717-6.294 24.393C32.43 99.104 42.877 98.88 54.63 79.623h46.816c5.72 0 10.395-4.687 10.395-10.408v-58.82C111.842 4.686 107.168 0 101.447 0H10.395C4.673 0 0 4.686 0 10.395v59.281c.249 5.51 4.823 9.947 10.395 9.947"
            fill="#FBFBFB"
            mask="url(#m6sm88bjdb)"
          />
        </g>
        <path
          d="M124.978 24.303h-10.109a4.398 4.398 0 0 1 0-8.794h10.109a4.397 4.397 0 1 1 0 8.794m57.211 0h-35.224a4.398 4.398 0 0 1 0-8.794h35.224a4.397 4.397 0 1 1 0 8.794M182.19 44.209h-67.32a4.398 4.398 0 0 1 0-8.795h67.32a4.397 4.397 0 1 1 0 8.795M150.093 64.114H114.87a4.398 4.398 0 0 1 0-8.794h35.223a4.397 4.397 0 1 1 0 8.794m32.096 0H172.08a4.397 4.397 0 0 1 0-8.794h10.11a4.397 4.397 0 0 1 0 8.794"
          fill="#4BA3C0"
        />
        <g transform="translate(0 5.936)">
          <mask id="st4lf512vd" fill="#fff">
            <use xlinkHref="#aibu7efh9c" />
          </mask>
          <path
            d="M216.344 138.8c0 7.99-6.498 14.487-14.486 14.487h-4.109c3.589-8.297 5.478-17.298 5.478-26.576 0-9.304-1.949-18.32-5.521-26.577h4.152c7.988 0 14.486 6.492 14.486 14.474V138.8zM23.268 153.288c-7.98 0-14.473-6.498-14.473-14.486v-24.193c0-7.98 6.493-14.474 14.473-14.474h4.113a66.992 66.992 0 0 0-5.468 26.577 66.955 66.955 0 0 0 5.47 26.576h-4.115zm-9.612-134.88c0-5.3 4.312-9.613 9.612-9.613 5.308 0 9.626 4.312 9.626 9.613 0 5.308-4.318 9.625-9.626 9.625-5.3.001-9.612-4.317-9.612-9.625zM201.858 91.34h-8.75a67.735 67.735 0 0 0-29.688-26.06 4.397 4.397 0 0 0-3.619 8.015c21.038 9.5 34.631 30.468 34.631 53.416 0 32.29-26.275 58.56-58.572 58.56H89.28c-32.297 0-58.573-26.27-58.573-58.56 0-32.297 26.276-58.573 58.573-58.573h8.937a4.398 4.398 0 0 0 0-8.795H89.28c-24.182 0-45.425 12.81-57.31 31.997h-4.304V36.293c8.04-1.978 14.022-9.244 14.022-17.886C41.688 8.257 33.425 0 23.269 0 13.119 0 4.862 8.257 4.862 18.407c0 8.64 5.977 15.906 14.01 17.885V91.76C8.136 93.823 0 103.28 0 114.608V138.8c0 12.836 10.438 23.28 23.269 23.28h8.705c11.886 19.18 33.127 31.983 57.306 31.983h46.58c17.921 0 34.819-7.025 47.578-19.78a68.303 68.303 0 0 0 9.702-12.203h8.718c12.837 0 23.28-10.444 23.28-23.28v-24.193c0-12.831-10.442-23.27-23.28-23.27z"
            fill="#FFF"
            mask="url(#st4lf512vd)"
          />
        </g>
        <path
          d="M75.444 135.802c-4.21 0-7.767-5.115-7.767-11.17 0-6.056 3.557-11.171 7.767-11.171 4.205 0 7.756 5.116 7.756 11.17 0 6.055-3.552 11.171-7.756 11.171m0-31.136c-9.133 0-16.563 8.956-16.563 19.965 0 11.01 7.43 19.965 16.563 19.965 9.126 0 16.55-8.956 16.55-19.965 0-11.008-7.424-19.965-16.55-19.965M96.556 160.496a4.397 4.397 0 0 0-.005 6.218c4.279 4.287 9.968 6.648 16.018 6.648 6.052 0 11.74-2.361 16.019-6.648a4.397 4.397 0 1 0-6.224-6.213 13.75 13.75 0 0 1-9.795 4.066 13.751 13.751 0 0 1-9.794-4.066 4.397 4.397 0 0 0-6.219-.005zM149.695 113.46c4.204 0 7.755 5.116 7.755 11.17 0 6.056-3.552 11.172-7.755 11.172-4.211 0-7.768-5.115-7.768-11.171 0-6.055 3.558-11.17 7.768-11.17m0 31.136c9.125 0 16.55-8.956 16.55-19.965 0-11.01-7.425-19.966-16.55-19.966-9.133 0-16.563 8.956-16.563 19.966 0 11.008 7.43 19.965 16.563 19.965"
          fill="#FFF"
        />
      </g>
    </svg>
  )
}

export default ChatBotIcon
